<template>
  <div>
    <card-list
      title="Item List"
      dataUrl="/api/v1/product"
      dataSize="10"
      :dataHeaders="tHeaders"
      deleteEndpoint="/api/v1/product"
      editRoute="/master/item/add"
    />
  </div>
</template>
<script>
import CardList from '../../components/CardList'

export default {
  name: "ProductList",
  components: {
    CardList
  },
  data () {
    return {
      tHeaders: [
        { name: 'Name', align: 'left' },
        { unit: 'Type', align: 'center' },
        { min_stock: 'Min Stock', align: 'center' },
      ],
    }
  },
};
</script>
